module.exports = __webpack_public_path__ + "img/workContents03-03_play.c937a11b.gif";